<template>
    <div v-if="organizationId" class="bg-gray-600 ">
         <div class="flex flex-row flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
            <v-nav-link v-for="r in routes" v-show="r.show" :href="r.route" :active="r.active">
                {{ r.name }}
            </v-nav-link>
         </div>
        <div v-for="r in routes">
            <div  v-if="r.active && r.routes" class="flex flex-row flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
                <v-nav-link v-for="sub in r.routes" v-show="sub.show" :href="sub.route" :active="sub.active">
                    {{ sub.name }}
                </v-nav-link>
            </div>
        </div>
    </div>
</template>

<script>
import VNavLink from "@/Components/NavLink";

export default {
    components: {
        VNavLink,
    },
    props: {
        organizationId: {
            type: String,
        },
    },
    data() {
        return {
            routes: [
                {
                    name: 'Организация',
                    route: this.route('organization', this.organizationId),
                    active: this.route().current('organization'),
                    show: true,
                },
                {
                    name: 'Пользователи',
                    route: this.route('organization.users', this.organizationId),
                    active: this.route().current('organization.users'),
                    show: this.access('organizations', 'users'),
                },
                {
                    name: 'Тарифы',
                    route: this.route('organization.tariffs', this.organizationId),
                    active: this.route().current('organization.tariffs'),
                    show: this.access('organizations', 'tariffs'),
                },
                {
                    name: 'Биржи',
                    route: this.route('organization.exchanges', this.organizationId),
                    active: this.route().current('organization.exchanges'),
                    show: this.access('exchanges', 'available'),
                },
                {
                    name: 'Авансовый баланс',
                    route: this.route('organization.advanced', this.organizationId),
                    active: this.route().current().startsWith('organization.advanced'),
                    show: this.access('organizations', 'advanced'),
                },
                {
                    name: 'Адреса',
                    route: this.route('organization.addresses', this.organizationId),
                    active: this.route().current('organization.addresses'),
                    show: this.access('organizations', 'addresses'),
                },
                {
                    name: 'Фиат',
                    route: this.route('organization.fiat', this.organizationId),
                    active: this.route().current('organization.fiat'),
                    show: this.access('organizations', 'fiat'),
                },
                {
                    name: 'Аналитика транзакций',
                    route: this.route('organization.analytics', this.organizationId),
                    active: this.route().current('organization.analytics'),
                    show: this.access('organizations', 'analytics'),
                },
                {
                    name: 'Выводы',
                    route: this.route('organization.withdrawals', this.organizationId),
                    active: this.route().current('organization.withdrawals'),
                    show: this.access('organizations', 'withdrawals'),
                },
                {
                    name: 'Ордера',
                    route: this.route('organization.orders', this.organizationId),
                    active: this.route().current('organization.orders'),
                    show: this.access('organizations', 'orders'),
                },
            ],
        }
    },
}
</script>
